import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { Dialog, Button, makeStyles, Typography, IconButton, ButtonBase, Box } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { TabBar, Login } from '../../components';
import { CloseIcon, DropLeftIcon, DropRightIcon } from '../../components/Icon';
import {
  updateLoginInfoAction,
  UpDateNoteList,
  UpDateDeleteNoteList,
  ResetNoteList,
  ResetDeleteNoteList,
  UpDatePostDayNoteList,
  ResetPostDayNoteList,
  UpDateFollowNoteList,
  ResetFollowNoteList,
  UpDateNotificationNoteList,
  ResetNotificationNoteList,
  AddTotal,
  ReduceTotal,
  ResetTotal,
  RefreshNotificationTotal,
  seenAndRefreshNotificationTotal,
  setEhdSetting
} from '../../redux/actions';
import { i18n } from '../../language';
import { ehandoverAPI, systemAPI } from '../../apis';
import { authNameE } from '../../utils/userFuncs';
import ehandoverIds from '../../ids/Ehandover';
import StyleButton from '../../components/StyleButton';
import useRetryApi from '../../utils/useRetryApi';
import DiaLog from '../../components/Dialog';
import SettingIcon from '../../static/images/settingIcon.png';
import rouMap from '../../router';
import { getRoleTypeColor, revampTemplateData } from '../../utils/eHandoverUtil';
import { WardStaffList, CreateNote, NewNotes } from './components';
import { EHANDOVER_TAB_IDS } from './constants/config';
import { createInitialTabData, getTabDynamicTitle as getEhandoverTabDynamicTitle } from './constants/tabHelpers';
import { createCommonNewNotesProps, getNotesPropsByType, mapTabDataWithComponents } from './helpers/tabNotesBuilder';
import { createInitialTabListStateById, createTabCountsById, createTabStateById } from './helpers/tabStateView';
import useEhandoverExport from './hooks/useEhandoverExport';
import useEhandoverListManager from './hooks/useEhandoverListManager';
import useEhandoverPageActions from './hooks/useEhandoverPageActions';
import useEhandoverPageEffects from './hooks/useEhandoverPageEffects';
import OldNewNotes from './components/NewNotes/OldNewNotes'

const useStyle = makeStyles((theme) => ({
  root: {
    padding: '2.188rem 0 2.188rem 3.438rem',
    background: theme.palette.bodyBG,
    position: 'relative',
    overflow: 'auto',
    height: 'calc(100vh - 4.375rem)',
  },
  h1: {
    fontSize: '2.25rem',
    lineHeight: '3rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    fontFamily: 'NotoSans-Bold',
    letterSpacing: '-0.031rem',
  },
  note: {
    marginTop: '1.875rem',
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    backgroundColor: '#4c93ff',
    borderRadius: '0.5rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    textAlign: 'center',
    lineHeight: '1.25rem',
    fontWeight: '500',
    padding: '0.875rem 0',
    textTransform: 'inherit',
    color: theme.palette.font.white,
    height: '3rem',
    width: '8.875rem',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
  },
  dialog: {
    '& .MuiPaper-rounded': {
      marginTop: '-2.5rem',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.393rem 0.75rem rgba(0, 0, 0, 0.04)',
    },
  },
  dialogIcon: {
    fontSize: '1rem',
    color: '#5f9df6',
    float: 'right',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  btn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  staffButton: {
    padding: '0',
    position: 'fixed',
    top: '50%',
    bottom: '0',
    width: '1.5rem',
    height: '9.375rem',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '10px 0 0 10px',
  },
  iconBody: {
    width: '1.5rem',
    height: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: '0.875rem',
    color: theme.palette.font.white,
  },
  tabBarBtnBox: {
    display: 'flex',
    alignItems: 'center',
    gridGap: '0.5rem',
    marginRight: '1rem !important',
  },
  exportButton: {
    backgroundColor: '#538fff',
    border: 'unset',
    '&.Mui-disabled': {
      backgroundColor: '#c0c6cb',
    },
  },
  exportContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.6rem',
    color: '#2e4469',
  },
}));

const PageEHandover = ({
  isLogin,
  wardId,
  setNoteList,
  setDeleteNoteList,
  resetNoteList,
  resetDeleteNoteList,
  addTotal,
  reduceTotal,
  resetTotal,
  followTotal,
  resetPostDayNoteList,
  setPostDayNoteList,
  rouList,
  setFollowNoteList,
  resetFollowNoteList,
  roleMap,
  upDateNotificationNoteList,
  resetNotificationNoteList,
  refreshNotificationTotal,
  seenAndRefreshNotificationTotal,
  expiryLogin,
  setEhdSetting,
  isNotToSendAsDefault,
  sinkCompletedToBottom,
  ehdSetting
}) => {
  const classes = useStyle();
  const createNoteComponentRef = useRef(null);
  const scrollableRef = useRef(null);
  const hasPrefetchedInitialTotalsRef = useRef(false);
  const [cloneWarningDialogState, setCloneWarningDialogState] = useState({
    isOpen: false,
    isCloneWarning: true,
    confirmCallback: () => {},
  });
  const history = useHistory();
  const [tabListStateById, setTabListStateById] = useState(() => createInitialTabListStateById());
  const [myDraftLoaded, setMyDraftLoaded] = useState(false);

  const [staffList, setStaffList] = useState([]);
  const [wardStaffListCtrl, setWardStaffListCtrl] = useState(false);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState(moment().add(-2, 'years').format('yyyy-MM-DD 00:00'));
  const [endDate, setEndDate] = useState(moment().format('yyyy-MM-DD HH:mm'));
  const [tagList, setTagList] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [individualUsers, setIndividualUsers] = useState(null);
  const loginInfo = useSelector((state) => state.loginInfo);
  const language = useSelector((state) => state.settings.language);
  const { retryApiCall } = useRetryApi();
  const [tempFlag, setTempFlag] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [exportPopup, setExportPopup] = useState(false);
  const [viewSettingReady, setViewSettingReady] = useState(false);
  const [loginTabSetupReady, setLoginTabSetupReady] = useState(false);
  const [initialTabSetupReady, setInitialTabSetupReady] = useState(false);
  const [followUpFilter, setFollowUpFilter] = useState('2');
  const [followUpTotal, setFollowUpTotal] = useState([
    {
      text: '0',
      value: '2',
    },
    {
      text: '0',
      value: '5',
    },
  ]);
  const [quickDays, setQuickDays] = useState('');
  const [accessControl, setAccessControl] = useState(null);
  const [sortOrder, setSortOrder] = useState({
    // PRIORITY: 'desc',
    DATE_START: 'desc',
    // CREATED_DATE: 'desc',
  });
  const [open, setOpen] = useState(false);
  // 标记是否有待执行的操作,登录后继续执行
  const [pendingAction, setPendingAction] = useState(null);
  const [requiredAcknowLedge, setRequiredAcknowLedge] = useState(false);
  const [isHideCompletedItem, setHideCompletedItem] = useState(false);
  const [tabData, setTabData] = useState(() =>
    createInitialTabData({
      i18n,
      tabCountsById: createTabCountsById({
        followTotal,
        tabListStateById: createInitialTabListStateById(),
      }),
    })
  );
  // 获取当前的tab
  const currentTabId = useMemo(() => {
    return _.find(tabData, (item) => item?.flag)?.id;
  }, [tabData]);
  // 不是notification tab并且有export权限才显示export button
  const showExportBtn = useMemo(() => {
    return currentTabId !== 'NOTIFICATION_TAB' && roleMap[authNameE.eHandover_export];
  }, [currentTabId, roleMap]);
  // 这里的tagNames用于export和10分钟自动call api刷新list
  const tagNames = useMemo(() => _.map(selectedTags, (item) => item.tagName), [selectedTags]);
  const [templateList, setTemplateList] = useState([]);
  const [showPinTab, setShowPinTab] = useState(false);

  // 统一把各 tab 当前的 total 收成只读映射，方便标题和后续 tab state 收口复用。
  // 这一步不改变任何底层 state，只是把“怎么读”从散变量切成按 tab 维度查看。
  const tabCountsById = useMemo(
    () =>
      createTabCountsById({
        followTotal,
        tabListStateById,
      }),
    [followTotal, tabListStateById]
  );

  // 根据api返回来的总数获取当前tab的动态title
  const getTabDynamicTitle = useCallback(
    (tabId, originalTitle) => {
      return getEhandoverTabDynamicTitle({
        tabId,
        originalTitle,
        i18n,
        myDraftLoaded,
        tabCountsById,
      });
    },
    [language, myDraftLoaded, tabCountsById]
  );
  // 获取所有tab里面需要展示的那些
  const displayTabData = useMemo(() => {
    return _.filter(tabData, (item) => item?.isShow).map((item) => ({
      ...item,
      title: getTabDynamicTitle(item.id, item.title),
    }));
  }, [tabData, getTabDynamicTitle]);

  const handleFollowUpFilter = useCallback((value) => {
    setFollowUpFilter(value);
  }, []);

  // 统一按 tabId 覆盖当前 tab 的 list / next / total。
  // 这里直接写统一的 tabListStateById，让 tab 列表数据真正集中到一份对象 state 里。
  const replaceTabListState = useCallback((tabId, { list, next, total }) => {
    setTabListStateById((prev) => ({
      ...prev,
      [tabId]: {
        ...prev[tabId],
        ...(typeof list !== 'undefined' ? { list } : {}),
        ...(typeof next !== 'undefined' ? { next } : {}),
        ...(typeof total !== 'undefined' ? { total } : {}),
      },
    }));
  }, []);

  // 统一按 tabId 追加分页 list，并同步 next。
  // notification 仍保持现有“返回整页更大结果后整体覆盖”的模式，所以这里不处理它的 append。
  const appendTabListState = useCallback((tabId, { list, next }) => {
    setTabListStateById((prev) => ({
      ...prev,
      [tabId]: {
        ...prev[tabId],
        list: [...(prev[tabId]?.list ?? []), ...list],
        ...(typeof next !== 'undefined' ? { next } : {}),
      },
    }));
  }, []);

  // 统一更新某个 tab 的标题 total，不触碰它当前的 list / next。
  const updateTabTotalState = useCallback(
    (tabId, total) => {
      replaceTabListState(tabId, { total });
    },
    [replaceTabListState]
  );

  // 把 EHandover 页面里“列表请求 + total 刷新”的实现统一收进模块内 hook。
  // 页面本体只保留场景编排和 UI，后面再改首屏/切 tab/search 时会更容易定位入口。
  const {
    handleFilter,
    getAcknowledgeTaskAPI,
    getAllTaskAPI,
    getChecklistTaskAPI,
    getCompleteTask,
    getDeletedTaskAPI,
    getMyDraftTask,
    getNotificationList,
    getOutstandingTask,
    getPinnedTask,
    getPostdayTaskAPI,
    loadActiveTabList,
    prefetchInitialOtherTabTotals,
    refreshAllTabTotals,
    refreshChecklistSiblingTotal,
    refreshChecklistTabs,
    refreshSelectiveTotalsByActiveTab,
  } = useEhandoverListManager({
    addTotal,
    currentTabId,
    endDate,
    followUpFilter,
    isLogin,
    loginInfo,
    notificationTaskLength: tabListStateById[EHANDOVER_TAB_IDS.NOTIFICATION_TAB]?.list?.length ?? 0,
    appendTabListState,
    reduceTotal,
    refreshNotificationTotal,
    replaceTabListState,
    requiredAcknowLedge,
    retryApiCall,
    search,
    setFollowUpTotal,
    sortOrder,
    startDate,
    tabData,
    tagNames,
    updateTabTotalState,
  });

  // call api更新所有tab的数据
  const updateData = () => {
    (async () => {
      await loadActiveTabList({ search, startDate, endDate, tag: tagNames });
    })();

    // 右边的员工数据
    (async () => {
      await getStaffListAPI();
    })();

    (async () => {
      await refreshAllTabTotals({ search, startDate, endDate, tag: tagNames });
    })();

    setRefresh((old) => !old);
  };

  // delete task API
  const deleteTaskAPI = async (TASK_ID, name, reLoad, tab, options = {}) => {
    try {
      const params = { taskId: TASK_ID, deletedBy: name };
      if (tab === 'postDay') {
        params.isJustThisOne = options?.isJustThisOne ?? false;
        await ehandoverAPI.deleteScheduleTask(params);
      } else if (tab === 'myDraft') {
        await ehandoverAPI.deleteTaskDraft(params);
      } else {
        await ehandoverAPI.postDeleteTask(params);
      }
      reLoad();
    } catch (error) {}
  };

  // pin task API
  const pinTaskAPI = async ({ taskId, pin, reLoad, isManualUnpin, pinExpiryDate }) => {
    try {
      await ehandoverAPI.postPinTask({
        taskId,
        priority: pin,
        isManualUnpin,
        pinExpiryDate,
      });
      if (_.isFunction(reLoad)) reLoad();
    } catch (error) {
      console.log('-----Pin/UnPin Task error----->', error);
    }
  };

  // pin noti API
  const pinNotiAPI = async ({ taskId, pin, reLoad, isManualUnpin, pinExpiryDate }) => {
    try {
      await systemAPI.pinNotification({
        notificationId: taskId,
        isPin: Number(pin) === 1 ? '0' : '1',
        isManualUnpin,
        pinExpiryDate,
      });
      if (_.isFunction(reLoad)) reLoad();
    } catch (error) {
      console.log('-----Pin/UnPin Noti error----->', error);
    }
  };

  // get staff list API
  const getStaffListAPI = async () => {
    try {
      const time = moment().format('YYYY-MM-DD');
      const { result } = await ehandoverAPI.getSrsStaffList(
        {
          wardId,
          timeStart: time,
          timeEnd: time,
        },
        { isHideLoading: true }
      );
      let newList = [];
      if (Array.isArray(result.roster_list) && result.roster_list.length > 0) {
        newList = _.map(result.roster_list, (item) => {
          return {
            id: item.corp_id,
            text: item.staff_name || item.corp_id,
            value: item.corp_id.toUpperCase(),
            color: getRoleTypeColor(item?.role ?? ''),
          };
        });
      }
      setStaffList(newList);
    } catch (error) {}
  };

  // get tag list API
  const getTagListAPI = async () => {
    try {
      const { result } = await ehandoverAPI.getTagList({}, { isHideLoading: true });
      setTagList(
        _.map(result, (item) => {
          return {
            text: item.tagDesc,
            tagName: item.tagName,
            id: item?.id,
            tagId: item?.id,
            value: item?.id,
          };
        })
      );
    } catch (error) {}
  };

  useEffect(() => {
    if (tempFlag) {
      updateData();
    } else {
      (async () => {
        await getStaffListAPI();
      })();
      (async () => {
        await getTagListAPI();
      })();
    }
    setTempFlag(true);
  }, [rouList]);

  // 定时30分钟call api更新所有tab的数据
  useEffect(() => {
    if (expiryLogin.isOpen ?? false) {
      return;
    }

    const timmer = setTimeout(updateData, [30 * 60 * 1000]);

    return () => {
      clearTimeout(timmer);
    }
  }, [refresh,  search, startDate, endDate, tagNames, expiryLogin.isOpen]);

  const sentTabList = tabListStateById[EHANDOVER_TAB_IDS.SENT_TAB]?.list ?? [];
  const checklistTabList = tabListStateById[EHANDOVER_TAB_IDS.CHECKLIST_TAB]?.list ?? [];
  const deletedTabList = tabListStateById[EHANDOVER_TAB_IDS.DELETED_TAB]?.list ?? [];
  const scheduleTabList = tabListStateById[EHANDOVER_TAB_IDS.SCHEDULE_TAB]?.list ?? [];
  const notificationTabList = tabListStateById[EHANDOVER_TAB_IDS.NOTIFICATION_TAB]?.list ?? [];

  // 列表数据现在已经在 useEhandoverListManager 内格式化完成。
  // 页面层只保留 redux note list 的同步，不再承担 tab 数据的二次转换。
  useEffect(() => {
    resetNoteList();
    _.forEach(sentTabList, (item) => {
      setNoteList(item.TASK_ID);
    });
  }, [resetNoteList, sentTabList, setNoteList]);

  useEffect(() => {
    resetDeleteNoteList();
    _.forEach(deletedTabList, (item) => {
      setDeleteNoteList(item.TASK_ID);
    });
  }, [deletedTabList, resetDeleteNoteList, setDeleteNoteList]);

  useEffect(() => {
    resetPostDayNoteList();
    _.forEach(scheduleTabList, (item) => {
      setPostDayNoteList(item.TASK_ID);
    });
  }, [resetPostDayNoteList, scheduleTabList, setPostDayNoteList]);

  useEffect(() => {
    resetFollowNoteList();
    resetTotal(0);
    _.forEach(checklistTabList, (item) => {
      setFollowNoteList(item.TASK_ID);
    });
    addTotal(followUpTotal[0]?.text ?? 0);
  }, [addTotal, checklistTabList, followUpTotal, resetFollowNoteList, resetTotal, setFollowNoteList]);

  useEffect(() => {
    resetNotificationNoteList();
    _.forEach(notificationTabList, (item) => {
      upDateNotificationNoteList(item);
    });
  }, [notificationTabList, resetNotificationNoteList, upDateNotificationNoteList]);

  useEffect( () => {
    (async () => {
      const { result } = await ehandoverAPI.getSettingList({wardId});
      setEhdSetting(result);
      let sinkCompletedChecklist = (result??[]).some(s => s.settingKey === "SINK_COMPLELTED_CHECKLIST_ITEM" && s.isEnable === "Y" && s.settingValue === "Y");
      setHideCompletedItem(sinkCompletedChecklist);
    })();
  }, [wardId])

  // 统一把各 tab 当前的 list / next / total 组织成只读视图。
  // 现在 tabListStateById 里已经是页面最终消费的数据结构，所以这里只做只读视图补充。
  const tabStateById = useMemo(
    () =>
      createTabStateById({
        myDraftLoaded,
        notificationTaskLength: tabListStateById[EHANDOVER_TAB_IDS.NOTIFICATION_TAB]?.list?.length ?? 0,
        tabCountsById,
        tabListStateById,
      }),
    [myDraftLoaded, tabCountsById, tabListStateById]
  );

  const { handleExport } = useEhandoverExport({
    currentTabId,
    endDate,
    followUpFilter,
    handleFilter,
    loginInfo,
    search,
    setExportPopup,
    setExporting,
    showPinTab,
    sortOrder,
    startDate,
    tagNames,
  });

  const {
    closeCloneWarningDialog,
    goToSettingPage,
    handleClose,
    handleResetSearchField,
    handleTabBarDataChange,
    openResetConfirmationDialog,
    submitClickHandle,
    tabOnClickExtraHandle,
  } = useEhandoverPageActions({
    createNoteComponentRef,
    currentTabId,
    endDate,
    history,
    myDraftLoaded,
    refreshChecklistSiblingTotal,
    rouMap,
    search,
    seenAndRefreshNotificationTotal,
    setCloneWarningDialogState,
    setEndDate,
    setMyDraftLoaded,
    setOpen,
    setQuickDays,
    setSearch,
    setSelectedTags,
    setSortOrder,
    setStartDate,
    setTabData,
    setRequiredAcknowLedge,
    startDate,
    tagNames,
    setHideCompletedItem,
    sinkCompletedToBottom
  });

  // 先整理所有 tab 共用的 NewNotes props，再按 tab type 补各自的数据源和特殊配置。
  // 这样后面新增/调整 tab 时，只需要去 helper 看“共用层”和“差异层”两处。
  const commonNewNotesProps = createCommonNewNotesProps({
    accessControl,
    endDate,
    // 共享筛选变化时：只刷新当前 active tab 的 list，再按规则补刷新其它 tab total。
    filterAPI: async ({ search, startDate, endDate, tag }) => {
      await loadActiveTabList({ search, startDate, endDate, tag });
      await refreshSelectiveTotalsByActiveTab({ search, startDate, endDate, tag });
    },
    handleReset: handleResetSearchField,
    individualUsers,
    pinTaskAPI,
    quickDays,
    refreshChecklistTabs,
    requiredAcknowLedge,
    search,
    selectedTags,
    setEndDate,
    setPendingAction,
    setQuickDays,
    setRequiredAcknowLedge,
    setSearch,
    setSelectedTags,
    setSortOrder,
    setStartDate,
    sortOrder,
    staffList,
    startDate,
    tagList,
    setHideCompletedItem,
    showHideCompleteItem: sinkCompletedToBottom,
    isHideCompletedItem,
    scrollableRef

  });

  const renderTabNotes = useCallback((type) => {
    const notesProps = getNotesPropsByType({
      commonProps: commonNewNotesProps,
      deleteTaskAPI,
      followUpFilter,
      followUpTotal,
      getAcknowledgeTaskAPI,
      getAllTaskAPI,
      getChecklistTaskAPI,
      getCompleteTask,
      getDeletedTaskAPI,
      getMyDraftTask,
      getNotificationList,
      getOutstandingTask,
      getPinnedTask,
      getPostdayTaskAPI,
      handleFollowUpFilter,
      notesData: tabStateById,
      pinNotiAPI,
      type,
    });
    const rollbackVirtualScrolling = (ehdSetting?.setting ?? []).some(s => s.settingKey === "ROLL_BACK_VC");
    return rollbackVirtualScrolling? <OldNewNotes {...notesProps} /> : <NewNotes {...notesProps} />;
  }, [ehdSetting,
    commonNewNotesProps,
    deleteTaskAPI,
    followUpFilter,
    followUpTotal,
    getAcknowledgeTaskAPI,
    getAllTaskAPI,
    getChecklistTaskAPI,
    getCompleteTask,
    getDeletedTaskAPI,
    getMyDraftTask,
    getNotificationList,
    getOutstandingTask,
    getPinnedTask,
    getPostdayTaskAPI,
    handleFollowUpFilter,
    tabStateById,
    pinNotiAPI,
  ]);

  // 这里仍然保持“字符串 component 需要即时实例化”的现有行为，不改 TabBar 的消费方式。
  const mappedTabData = mapTabDataWithComponents({
    displayTabData,
    renderTabNotes,
  });

  const getAccessControlListAPI = useCallback(async () => {
    try {
      const { result } = await ehandoverAPI.getSettingAccess();
      setAccessControl(result);
    } catch (error) {}
  }, []);

  const getTabIsShow = useCallback((tabItem, viewSetting) => {
    const showPinTab = viewSetting?.IS_RELOCATE_PIN_TAB_YN === 'Y';
    const separateCheckListTab = viewSetting?.IS_SEPARATE_CHECKLIST_TAB_YN === 'Y';
    const tabId = tabItem?.id;
    if (tabId === 'PIN_TAB') {
      return showPinTab;
    } else if (tabId === 'CHECKLIST_TAB') {
      return !separateCheckListTab;
    } else if (['OUTSTANDING_TAB', 'COMPLETED_TAB'].includes(tabId)) {
      return separateCheckListTab;
    } else {
      return tabItem?.isShow;
    }
  }, []);

  const getSettingViewList = useCallback(async () => {
    setViewSettingReady(false);
    try {
      const { result } = await ehandoverAPI.getSettingView({});
      setShowPinTab(result?.IS_RELOCATE_PIN_TAB_YN === 'Y');
      setTabData((prev) =>
        _.map(prev, (item) => {
          return {
            ...item,
            isShow: getTabIsShow(item, result),
          };
        })
      );
    } catch (error) {
    } finally {
      setViewSettingReady(true);
    }
  }, [getTabIsShow]);

  const getIndividualUsers = useCallback(async () => {
    try {
      const { result } = await ehandoverAPI.getIndividualUserList();
      const newRoomTypeList = _.map(result?.roomTypeList ?? [], (roomItem) => ({
        ...roomItem,
        color: roomItem?.role ? getRoleTypeColor(roomItem?.role ?? '') : 'unset',
      }));
      const newStaffList = _.map(result?.staffList ?? [], (roomItem) => ({
        ...roomItem,
        color: getRoleTypeColor(roomItem?.role ?? ''),
      }));
      setIndividualUsers({ roomTypeList: newRoomTypeList, staffList: newStaffList });
      await getTaskTemplateList({ roomTypeList: newRoomTypeList, staffList: newStaffList });
    } catch (error) {}
  }, []);

  const getTaskTemplateList = async (individualUsers) => {
    try {
      const { result } = await ehandoverAPI.getTaskTemplate();
      const templateList = result?.tasks ?? [];
      const taskIds = _.map(templateList, (taskItem) => taskItem?.id);

      // 根据所有template的taskId获取所有task里面的checklist
      const { result: checkListResult } = await ehandoverAPI.getNewTaskItemList(
        {
          order: { ID: 'asc', TOGGLED_DATE: 'asc', IS_COMPLETE: 'desc', SORT_INDEX: 'asc' },
          taskIdList: taskIds,
        },
        { isHideLoading: true }
      );

      const checkListGroupByTaskId = checkListResult.reduce((acc, item) => {
        const key = item.TASK_ID;
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
      }, {});
      const newTemplateList = _.map(templateList, (item) => {
        return revampTemplateData({
          templateItem: item,
          checkListGroup: checkListGroupByTaskId,
          individualUsers,
        });
      });
      setTemplateList(newTemplateList);
    } catch (error) {}
  };

  // 页面初始化、副作用恢复和登录态编排统一交给页面级 effect hook 处理。
  // index.js 这里只保留业务函数本体，不再自己组织多组初始化 useEffect。
  useEhandoverPageEffects({
    exporting,
    getAccessControlListAPI,
    getIndividualUsers,
    getSettingViewList,
    hasPrefetchedInitialTotalsRef,
    initialTabSetupReady,
    loginInfo,
    loginTabSetupReady,
    pendingAction,
    prefetchInitialOtherTabTotals,
    setExporting,
    setInitialTabSetupReady,
    setLoginTabSetupReady,
    setMyDraftLoaded,
    setPendingAction,
    setTabData,
    replaceTabListState,
    viewSettingReady,
  });

  return (
    <div>
      <div
        className={classes.root}
        style={{
          marginRight: wardStaffListCtrl ? '22.838rem' : '3.438rem',
          width: wardStaffListCtrl ? 'calc(100vw - 29.088rem)' : 'calc(100vw - 9.688rem)',
        }}
        id="ehandover-root"
        ref={scrollableRef} 
      >
        <div className={classes.head}>
          <Box display="flex" justifyContent="space-between" width="100%" gridGap="2rem">
            <Typography className={classes.h1}>{i18n.t('EHANDOVER_EHANDOVER')}</Typography>
            {!isLogin && (
              <Button
                className={classes.title}
                onClick={() => {
                  setOpen(true);
                }}
                id={`${ehandoverIds.login}1`}
              >
                {i18n.t('EHANDOVER_LOGIN')}
              </Button>
            )}
          </Box>
          <Dialog open={open} onClose={handleClose} className={classes.dialog}>
            <Login button={i18n.t('EHANDOVER_LOGIN_BUTTON')} submitClick={submitClickHandle}>
              <div className={classes.btn}>
                <IconButton
                  style={{
                    width: '1.25rem',
                    height: '1.25rem',
                    borderRadius: '0',
                    backgroundColor: '#ffffff',
                    marginRight: '-0.7rem',
                  }}
                  onClick={handleClose}
                  id={`${ehandoverIds.login}2`}
                >
                  <CloseIcon className={classes.dialogIcon} />
                </IconButton>
              </div>
            </Login>
          </Dialog>
        </div>
        {roleMap[authNameE.eHandover_create_note] && (
          <CreateNote
            ref={createNoteComponentRef}
            updateData={updateData}
            individualUsers={individualUsers}
            openResetConfirmationDialog={openResetConfirmationDialog}
            getIndividualUsers={getIndividualUsers}
            templateList={templateList}
            tagList={tagList}
            isNotToSendAsDefault={isNotToSendAsDefault}
          />
        )}
        <div className={classes.note}>
          <TabBar
            data={mappedTabData}
            // 这里不能改底层行为，不然会导致切换 tab 之后 react 组件实例更新不了。
            // 这里只是把原来的内联实现挪成命名方法，方便后续维护和排查。
            setData={handleTabBarDataChange}
            isLogin={isLogin}
            extraHandle={tabOnClickExtraHandle}
            width="8rem"
            wrapHeader
            inlineNotificationBtn
            NotificationBtn={
              <>
                {roleMap[authNameE.eHandover_setting] && (
                  <StyleButton
                    className={classes.exportButton}
                    color="#fff"
                    width="8rem"
                    id="ehandover_setting_button"
                    text={i18n.t('EHANDOVER_SETTING')}
                    alignItems="center"
                    onClick={goToSettingPage}
                    disabled={exporting}
                    borderRadius="0.714rem"
                    Icon={() => (
                      <img src={SettingIcon} alt="setting icon" style={{ width: '1.428rem', height: '1.428rem' }} />
                    )}
                  />
                )}
                {showExportBtn && (
                  <StyleButton
                    className={classes.exportButton}
                    color="#fff"
                    width="8rem"
                    borderRadius="0.714rem"
                    id="ehandover_export_button"
                    text={exporting ? i18n.t('EHANDOVER_EXPORTING') : i18n.t('EQUIPMENT_VIEWREQUEST_EXPORT')}
                    onClick={() => setExportPopup(true)}
                    disabled={exporting}
                  />
                )}
              </>
            }
          />
        </div>
      </div>
      <ButtonBase
        id={ehandoverIds.staff}
        className={classes.staffButton}
        onClick={() => setWardStaffListCtrl((old) => !old)}
        style={{ right: wardStaffListCtrl ? '19.438rem' : 0 }}
      >
        <div className={classes.iconBody}>
          {wardStaffListCtrl ? <DropRightIcon className={classes.icon} /> : <DropLeftIcon className={classes.icon} />}
        </div>
      </ButtonBase>
      {wardStaffListCtrl && <WardStaffList wardStaffdata={staffList} />}
      {exportPopup && (
        <DiaLog
          open={true}
          confirm={i18n.t('EHANDOVER_CONFIRM_EXPORT_OK')}
          cancel={i18n.t('EHANDOVER_NOTE_DELETE_CANCEL')}
          handleCancel={() => setExportPopup(false)}
          handleClose={() => setExportPopup(false)}
          handleConfirm={handleExport}
          haveHead={false}
        >
          <div className={classes.exportContent}>{i18n.t('EHANDOVER_CONFIRM_EXPORT')}</div>
        </DiaLog>
      )}
      {cloneWarningDialogState.isOpen && (
        <DiaLog
          open={cloneWarningDialogState.isOpen}
          onClose={closeCloneWarningDialog}
          confirm={i18n.t('EHANDOVER_NOTE_DELETE_CONFIRM')}
          cancel={i18n.t('EHANDOVER_NOTE_DELETE_CANCEL')}
          handleCancel={() => {
            closeCloneWarningDialog();
          }}
          handleClose={() => {
            closeCloneWarningDialog();
          }}
          handleConfirm={cloneWarningDialogState.confirmCallback}
          haveHead={false}
        >
          <div className={classes.exportContent}>
            {cloneWarningDialogState.isCloneWarning
              ? i18n.t('EHANDOVER_CLONE_WARNING')
              : i18n.t('EHANDOVER_RESET_WARNING')}
          </div>
        </DiaLog>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLogin: state.loginInfo.flag,
  wardId: state.loginInfo.wardId,
  followTotal: state.FolowTotal,
  rouList: state.rouList,
  roleMap: state.roleMap,
  expiryLogin: state.expiryLogin,
  ehdSetting: state.ehdSetting,
  isNotToSendAsDefault: state.ehdSetting.isNotToSendAsDefault,
  sinkCompletedToBottom: state.ehdSetting.sinkCompletedChecklist
});

const mapDispatchToProps = (dispatch) => ({
  setUpLogin: ({ isLogin, ...reset }) => {
    dispatch(updateLoginInfoAction({ flag: isLogin, ...reset }));
  },
  setNoteList: (taskId) => {
    dispatch(UpDateNoteList(taskId));
  },
  setDeleteNoteList: (taskId) => {
    dispatch(UpDateDeleteNoteList(taskId));
  },
  resetNoteList: () => {
    dispatch(ResetNoteList());
  },
  resetDeleteNoteList: () => {
    dispatch(ResetDeleteNoteList());
  },
  addTotal: (num) => {
    dispatch(AddTotal(num));
  },
  reduceTotal: (num) => {
    dispatch(ReduceTotal(num));
  },
  resetTotal: (total) => {
    dispatch(ResetTotal(total));
  },
  setPostDayNoteList: (taskId) => {
    dispatch(UpDatePostDayNoteList(taskId));
  },
  resetPostDayNoteList: () => {
    dispatch(ResetPostDayNoteList());
  },
  setFollowNoteList: (taskId) => {
    dispatch(UpDateFollowNoteList(taskId));
  },
  resetFollowNoteList: () => {
    dispatch(ResetFollowNoteList());
  },
  upDateNotificationNoteList: (data) => {
    dispatch(UpDateNotificationNoteList(data));
  },
  resetNotificationNoteList: () => {
    dispatch(ResetNotificationNoteList());
  },
  refreshNotificationTotal: () => {
    dispatch(RefreshNotificationTotal());
  },
  seenAndRefreshNotificationTotal: () => {
    dispatch(seenAndRefreshNotificationTotal());
  },
  setEhdSetting: (data) => {
    dispatch(setEhdSetting(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PageEHandover);
